import './userList.css'
import {NavLink} from "react-router-dom";
import React, {useEffect, useRef, useState} from "react";
import axios from "axios";
import ReactPaginate from 'react-paginate';
import {useParams} from "react-router";
const apiUrl = process.env.REACT_APP_API;
function UserList() {

    const MyEnum = {
        0: 'Սպասվում է',
        1: 'Մասնակցած',
        2: 'Մերժված'
    }
    const [state, setState] = useState([{
        address: '',
        arrive: null,
        blockReason: null,
        bonusCard: '',
        email: '',
        firstName: '',
        lastName: '',
        phoneNumber: null,
        userId: null,
        approvedDate: null,
    }]);
    let {userId: userId} = useParams();
    const [stateUserId,setUserId] =useState('')
    const [bonus, setBonus] = useState('')
    const [currentPage, setCurrentPage] = useState(1)
    const [page, setPage] = useState()
    const [phone, setPhone] = useState('')
    const [arrive, setArrive] = useState('')
    const [blockReason, setBlockReason] = useState('')
    const [code, setCode] = useState();

    let reasonInput = useRef(null)
    let popUpBlock = useRef(null)
    useEffect(() => {
        getConfirmCode().then(res => {
            let generateCode = res * 12 - 48 / 3 + 94 * 31;
            getUsersList(generateCode).then(res => {
                setState(res)
            })
        });
    }, [])

    let pageX = Math.round(page / 8);

    const getConfirmCode = async () => {
        let res = await axios.get(`${apiUrl}/user/getconfirmcode`, {})
        let {data} = res;
        return data;
    }

    function changePage(e) {
        let x = e.selected;
        const getUsersList = async (generateCode) => {
            let res = await axios.post(`https://mallapi.yerevan-city.am/api/user/getusers/${generateCode}`, {
                'page': x,
                'count': 8,
            })
            let {data} = res;
            let pageCount = data.pagesCount;
            setPage(pageCount)
            // setCurrentPage(x)
            return data.users;
        }
        getConfirmCode().then(res => {
            let generateCode = res * 12 - 48 / 3 + 94 * 31;
            getUsersList(generateCode).then(res => {
                setState(res)
                // setCurrentPage(x)
            })
            // setCurrentPage(x)
        });
        // setCurrentPage(x)
    }

    const getUsersList = async (generateCode) => {
        let res = await axios.post(`${apiUrl}/user/getusers/${generateCode}`, {
            'page': 1,
            'count': 8,
        })
        let {data} = res;
        let pageCount = data.pagesCount;
        setPage(pageCount)
        return data.users;
    }

    const downloadUsersExcel = async (generateCode) => {
        let fileName = await axios.post(`${apiUrl}/user/downloadusersexcel/${generateCode}`, {
            arrive: arrive,
            bonusCard: bonus,
            phoneNumber: phone
        });
        const link  = `${apiUrl}/user/downloadexcelfile/${fileName.data}`;
        window.open(link, '_blank');
    }

    function download(e) {
        e.preventDefault();
        getConfirmCode().then(res => {
            let generateCode = res * 12 - 48 / 3 + 94 * 31;
            downloadUsersExcel(generateCode).then();
        });
            //downloadBtn.current.setAttribute('href', `${apiUrl}/user/downloadexcelfile/user.xlsx`);
    }

    function filterBonusHandler(e) {
        if (e.target.value === '') {
            getConfirmCode().then(res => {
                let generateCode = res * 12 - 48 / 3 + 94 * 31;
                getUsersList(generateCode).then(res => {
                    setState(res)
                })
            });
        } else {
            getConfirmCode().then(res => {
                let generateCode = res * 12 - 48 / 3 + 94 * 31;
                filterBonus(generateCode, e.target.value).then(res => {
                    setState(res)
                })
            });
        }

    }

    function filterStatusHandler(e) {
        if (e.target.value === '') {
            getConfirmCode().then(res => {
                let generateCode = res * 12 - 48 / 3 + 94 * 31;
                getUsersList(generateCode).then(res => {
                    setState(res)
                })
            })

        } else {
            getConfirmCode().then(res => {
                let generateCode = res * 12 - 48 / 3 + 94 * 31;
                filterStatus(generateCode, e.target.value).then(res => {
                    setState(res)
                })
            })
        }

    }

    function filterPhoneHandler(e) {
        if (e.target.value === '') {
            getConfirmCode().then(res => {
                let generateCode = res * 12 - 48 / 3 + 94 * 31;
                getUsersList(generateCode).then(res => {
                    setState(res)
                })
            });
        } else {
            getConfirmCode().then(res => {
                let generateCode = res * 12 - 48 / 3 + 94 * 31;
                filterPhone(generateCode,e.target.value).then(res => {
                    setState(res)
                })
            });
        }
    }

    const filterBonus = async (generateCode, bonus) => {
        let res = await axios.post(`${apiUrl}/user/getusers/${generateCode}`, {
            'page': 1,
            'count': 8,
            'bonusCard': bonus,
        });
        let {data} = res;
        let pageCount = data.pagesCount;
        setPage(pageCount)
        return data.users;
    }

    const filterStatus = async (generateCode, status) => {
        let res = await axios.post(`${apiUrl}/user/getusers/${generateCode}`, {
            'page': 1,
            'count': 8,
            'arrive': status,
        })
        let {data} = res;
        let pageCount = data.pagesCount;
        setPage(pageCount)
        return data.users;
    }

    const filterPhone = async (generateCode) => {
        let res = await axios.post(`${apiUrl}/user/getusers/${generateCode}`, {
            'page': 1,
            'count': 8,
            'phoneNumber': phone,
        })
        let {data} = res;
        let pageCount = data.pagesCount;
        setPage(pageCount)
        return data.users;
    }

    function forDelete(userId) {
        userId = stateUserId;
        getConfirmCode().then(res => {
            let generateCode = res * 12 - 48 / 3 + 94 * 31;
            setCode(res)
            arriveHandlerDelete(generateCode,userId).then(res => {
                setState(res)
            });

        });
        setTimeout(() => {
            window.location.reload()
        }, 1000)
    }

    function forApprove(userId) {
        getConfirmCode().then(res => {
            let generateCode = res * 12 - 48 / 3 + 94 * 31;
            setCode(res)
            arriveHandlerApprove(generateCode,userId).then(res => {
                setState(res)
            });
        });
        setTimeout(() => {
            window.location.reload()

        }, 1000)
    }
    const arriveHandlerApprove = async (generateCode,userId) => {
        let res = await axios.post(`${apiUrl}/user/updateuser/${generateCode}`, {
            userId: userId,
            arrive: 1,
            blockReason: ''
        });
        let {data} = res;
        return data;
    }
    const arriveHandlerDelete = async (generateCode,userId) => {
        let res = await axios.post(`${apiUrl}/user/updateuser/${generateCode}`, {
            userId: userId,
            arrive: 2,
            blockReason: blockReason,
        });
        let {data} = res;
        return data;
    }

    function popUp(userId){
        setUserId(userId)
        popUpBlock.current.style.display = "flex";
    }
    function popUpClose(){
        popUpBlock.current.style.display = "none";
    }
    return (
        <div className='user-list-block'>
            <div className="popUp-block" ref={popUpBlock}>
                <div className="popUp-wrapper">
                                      <textarea ref={reasonInput} value={blockReason} onChange={e => setBlockReason(e.target.value)}
                                                className='info-cols' placeholder='Մերժելու պատճառը'/>
                    <div className='popUp-btn-block'>
                        <button className="forDelete" onClick={()=>{
                            forDelete(userId)
                        }}>Մերժել</button>
                        <button className="popUp-close" onClick={popUpClose}>Փակել</button>
                    </div>

                </div>
            </div>
            <div className="search-download-block">
                <form action="">
                    <input type="text" placeholder='Որոնել բոնուս քարտով' onChange={(e) => {
                        setBonus(e.target.value)
                        filterBonusHandler(e)
                    }}/>
                    <input type="number" placeholder='Որոնել հեռախոսահամրով'
                           value={phone}
                           onChange={(e) => {
                               setPhone(e.target.value)
                               filterPhoneHandler(e)
                           }}
                    />
                    <select value={arrive} onChange={(e) => {
                        setArrive(e.target.value)
                        filterStatusHandler(e)
                    }}>
                        <option value=''>Բոլորը</option>
                        <option value={0}>{MyEnum[0]}</option>
                        <option value={1}>{MyEnum[1]}</option>
                        <option value={2}>{MyEnum[2]}</option>

                    </select>
                </form>
                <button onClick={download}>Հավաքագրել</button>
                {/*<a ref={downloadBtn} href="" className="download-btn" >Ներբեռնել</a>*/}
            </div>
            <div className="table-block">
                <div className="info-titles-block">
                    <span>Անուն</span>
                    <span>Ազգանուն</span>
                    <span>Բոնուս Քարտ</span>
                    <span>Հասցե</span>
                    <span>Հեռ․ համար</span>
                    <span>Էլ․ հասցե</span>
                    <span>Ստատուս</span>
                    <span>Հաստատման/Մերժման օր</span>
                    <span>Մերժման պատժառ</span>
                    <span>Հաստատել/Մերժել</span>
                </div>


                {
                    state.map((item, index) => {
                        return (
                            <div className="cols-block" key={index}>
                                <div className='col'>
                                    {item.firstName}
                                </div>
                                <div className='col'>
                                    {item.lastName}
                                </div>
                                <div className='col'>
                                    {item.bonusCard}
                                </div>
                                <div className='col'>
                                    {item.address}
                                </div>

                                <div className='col'>
                                    {item.phoneNumber}
                                </div>
                                <div className='col'>
                                    {item.email}
                                </div>
                                <div className='col'>
                                    {
                                        item.arrive === 0 && <span className="pending">{MyEnum["0"]}</span> ||
                                        item.arrive === 1 && <span className="active">{MyEnum["1"]}</span> ||
                                        item.arrive === 2 && <span className="decline">{MyEnum["2"]}</span>
                                    }
                                </div>
                                <div className={item.approvedDate === null ? 'v_hidden col':'col'}>
                                    <span > {item.approvedDate ? item.approvedDate.split('T')[0] : ''} </span>
                                </div>
                                <div className={item.blockReason === ''?'v_hidden col':'col blockReason-col'}>
                                        <span > {item.blockReason ? item.blockReason : ''} </span>
                                         <span className={item.blockReason === ''?'v_hidden col': 'reason-tooltip'}>{item.blockReason }</span>
                                </div>
                                <div className={item.arrive === 1 || item.arrive === 2 ? 'v_hidden': 'info-btns-block'} >
                                    <button className="forApprove" onClick={()=>{
                                        forApprove(item.userId)
                                    }}>Հաստատել</button>
                                    <button className="forDelete" onClick={(e)=> {
                                        userId = item.userId
                                        popUp(userId)
                                    }}>Մերժել</button>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
            <div className="pagination-block">
                {/*{pageButton}*/}
                <ReactPaginate
                    breakLabel="..."
                    nextLabel={null}
                    onPageChange={(e) => {
                        changePage(e)
                    }}
                    pageRangeDisplayed={5}
                    pageCount={pageX}
                    previousLabel={null}
                    renderOnZeroPageCount={null}
                />
            </div>
        </div>
    );
}

export default UserList;
